import { OpsResultsTable, OpsResult } from './Data'
import React, { Component, useContext, useState } from 'react'
import {
  Anchor,
  Box,
  Button,
  CheckBox,
  DateInput,
  FormField,
  Grid,
  Heading,
  Layer,
  List,
  Main,
  MaskedInput,
  Menu,
  Paragraph,
  Select,
  Stack,
  Text
} from 'grommet'
import withOpsApi from './withOpsApi'
import { opsAPI, departments } from '../api/retail'

import { PageCard } from './Cards'
import { Analytics, DocumentImage, Globe, MoreVertical, Scan } from 'grommet-icons'
import PropTypes from 'prop-types'
import { MotionBox, MotionLayer } from './Motion'
import { AnimatePresence } from 'framer-motion'
import update from 'immutability-helper'
import { LoadingHeader } from './Common'
import { AppContext } from '../libs/context'
import { DonationReportPage } from './Donations'
import { BulkScanTable } from './BulkScan'
import { StorePosterPage } from './StorePosters'
import { labelByMode } from '../libs/common'

class InsertBulkScan extends Component {
  static defaultProps = {
    loadStoreMetrics: true,
    actions: {}
  }
  static contextType = AppContext
  state = {
    storeMetrics: [],
    loading: false,
    submitting: false,
    newWeights: {},
    entryDateISO: '',
    backDateISO: '',
    averageDayRange: 30,
    enableAllDepartments: false
  }
  setDepartmentWeight = (departmentId, value) => {
    this.setState({
      newWeights: update(this.state.newWeights, { [departmentId]: { $set: value } })
    })
  }
  setDate = (dateISO) => {
    const newDate = dateISO ? new Date(dateISO) : new Date()
    const backDate = new Date(newDate)
    backDate.setDate(backDate.getDate() - this.state.averageDayRange)
    this.setState({ entryDateISO: newDate.toISOString(), backDateISO: backDate.toISOString() })
  }
  // componentDidMount() {
  //   this.setDate()
  // }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevState.backDateISO !== this.state.backDateISO ||
      prevState.entryDateISO !== this.state.entryDateISO
    ) {
      this.loadStoreAverage()
    }
    if (prevState.averageDayRange !== this.state.averageDayRange) {
      this.setDate(this.state.entryDateISO)
    }

    // todo: enable this if we want to auto set all boxes checked on start.
    //  Not recommended as dates need to be set by user
    // if (
    //   prevState.storeMetrics !== this.state.storeMetrics &&
    //   this.state.enableAllDepartments === false
    // ) {
    //   this.setState({ enableAllDepartments: true })
    //   this.setAllAsChecked()
    // }
  }
  setAllAsChecked = (useAverages = true) => {
    let newWeights = {}
    departments.forEach((department) => {
      newWeights[department.id] = useAverages
        ? this.getStoreAverageWeight(department.id)
        : undefined
    })
    this.setState({ newWeights: newWeights })
  }
  loadStoreAverage = () => {
    const { entryDateISO, backDateISO, enableAllDepartments } = this.state
    if (this.props.loadStoreMetrics) {
      this.setState({ loading: true })
      // todo: getAvgWrtPerStore not set up correctly like other DRF endpoints, does not work if ending with `/`
      // todo: so parsing it through alternate method
      const response = opsAPI.getOpsFullPath('/api/retail/donations/getAvgWtPerStore', {
        from_store: this.props.store.id,
        entry_time__gte: backDateISO,
        entry_time__lte: entryDateISO
      })
      response
        .then((response) => {
          this.setState({
            storeMetrics: response.data.results,
            loading: false
          })
        })
        .catch((e) => {
          this.setState({ loading: false })
          this.context.actions.showResponseAsError(e)
        })
    }
  }
  getStoreMetrics = (departmentId) => {
    return this.state.storeMetrics.find((obj) => obj.from_department_id === departmentId) || {}
  }
  getStoreAverageWeight = (departmentId) => {
    const { avg_wt = 0.0 } = this.getStoreMetrics(departmentId)
    return Math.round(avg_wt)
  }
  submitWeights = () => {
    const { store, receiver, actions } = this.props
    const { newWeights, entryDateISO } = this.state
    const utcLocalDate = new Date(entryDateISO)
    // we need to compensate UTC time sent to be 7 hours behind to record PST time baked into UTC
    // due to behaviour set up in previous records
    utcLocalDate.setHours(utcLocalDate.getHours() - 7)
    const defaultData = {
      store_id: store.id,
      department: null,
      email: 'daemon@foodmesh.ca',
      weight_kg: null,
      receiver_id: receiver.id,
      destination: 1,
      entry_time: utcLocalDate.toISOString()
    }
    let data = []
    Object.keys(newWeights).forEach((key) => {
      if (newWeights[key] !== undefined) {
        data.push({ ...defaultData, weight_kg: newWeights[key], department: Number(key) })
      }
    })
    this.setState({ submitting: true })
    const response = opsAPI.postToRetail('bulkscan/', data)
    response
      .then((response) => {
        this.setState({ submitting: false }, () => {
          actions.bulkScanInserted && actions.bulkScanInserted()
          this.context.actions.showAsToast({
            title: receiver.name + ' + ' + store.name,
            message: response.data.length + ' weights inserted!',
            type: 'success'
          })
        })
      })
      .catch((e) => {
        this.setState({ submitting: false })
        this.context.actions.showResponseAsError(e)
      })
  }
  setChecked = (checked, departmentId) => {
    this.setDepartmentWeight(
      departmentId,
      checked ? this.getStoreAverageWeight(departmentId) : undefined
    )
  }
  allowSubmit = () => {
    const { submitting, newWeights, backDateISO, loading } = this.state
    let canSubmit = !submitting && !loading && Object.values(newWeights).filter(Boolean).length > 0
    if (this.props.loadStoreMetrics) {
      return canSubmit && (backDateISO ? true : false)
    }
    return canSubmit
  }
  getTotal = () => {
    const { newWeights } = this.state
    let total = 0
    departments.forEach((department) => {
      if (newWeights[department.id] !== undefined) {
        total += Number(newWeights[department.id])
      }
    })
    return total
  }
  render() {
    const { loading, submitting, newWeights, entryDateISO, averageDayRange } = this.state
    const { store, receiver, loadStoreMetrics } = this.props
    return (
      <Box fill background={'light-3'}>
        <LoadingHeader loading={loading || submitting} />

        <Main pad={{ horizontal: 'medium', top: 'xsmall', bottom: 'large' }} gap={'medium'}>
          <Box pad="medium" gap={'small'} flex={false}>
            <Heading level={2} color="dark-4" margin={'none'}>
              {receiver.name}
            </Heading>
            <Text weight={'bold'} color="dark-4" size={'small'}>
              For Store
            </Text>
            <Text weight={'bold'} color="dark-6">
              {store.name}
            </Text>
          </Box>
          <Box
            round={'small'}
            elevation={'small'}
            pad={'medium'}
            gap={'small'}
            background={'white'}
            flex={false}
          >
            <FormField key={'date'} label={'Entry For Date'}>
              <DateInput
                format="mm/dd/yyyy"
                calendarProps={{ size: 'medium', fill: true }}
                dropProps={{ pad: 'medium' }}
                value={entryDateISO}
                reverse
                onChange={({ value }) => {
                  this.setDate(value)
                }}
              />
            </FormField>
          </Box>

          <Box
            round={'small'}
            elevation={'small'}
            pad={'medium'}
            gap={'small'}
            background={'white'}
            flex={false}
          >
            <Box direction={'row'} justify="between" gap={'medium'}>
              <Box flex="shrink" gap={'xsmall'}>
                <Text
                  level={1}
                  color={'dark-6'}
                  weight={'bold'}
                  margin={{ vertical: 'xsmall', horizontal: 'none' }}
                >
                  Department
                </Text>
                <Box fill="vertical" flex={'shrink'} justify={'center'}>
                  <Text color={'black'}>All weights shown and submitted in KG.</Text>
                </Box>
              </Box>
              {loadStoreMetrics && (
                <Box width={'xsmall'} gap={'xsmall'}>
                  <Text
                    textAlign={'center'}
                    level={1}
                    color={'mesh-accent-blue'}
                    weight={'bold'}
                    margin={{ vertical: 'xsmall', horizontal: 'none' }}
                  >
                    Avg. Days
                  </Text>
                  <Select
                    disabled={!entryDateISO}
                    options={[7, 14, 30, 60, 120]}
                    value={averageDayRange}
                    onChange={({ value }) => this.setState({ averageDayRange: value })}
                  />
                </Box>
              )}
            </Box>
            <Box
              fill="horizontal"
              flex={false}
              height="4px"
              border={{ side: 'bottom', size: 'small' }}
            />
            <Grid rows={'auto'} columns={['auto', 'flex', 'xsmall']} gap="medium">
              {departments.map((department) => (
                <>
                  <Box
                    key={'chk_' + department.name}
                    fill={'vertical'}
                    margin={{ top: 'xsmall' }}
                    align={'start'}
                  >
                    <CheckBox
                      checked={newWeights[department.id] === undefined ? false : true}
                      onChange={(e) => this.setChecked(e.target.checked, department.id)}
                    />
                  </Box>
                  <FormField key={department.name} label={department.name}>
                    <MaskedInput
                      mask={[
                        {
                          length: 3,
                          regexp: /^[0-9]{1,3}$/,
                          placeholder: '0'
                        }
                      ]}
                      value={
                        newWeights[department.id] !== undefined ? newWeights[department.id] : ''
                      }
                      onChange={(event) =>
                        this.setDepartmentWeight(department.id, event.target.value)
                      }
                    />
                  </FormField>
                  <Button
                    hoverIndicator
                    disabled={loadStoreMetrics && loading ? true : false}
                    onClick={() =>
                      this.setDepartmentWeight(
                        department.id,
                        this.getStoreAverageWeight(department.id)
                      )
                    }
                    label={
                      <Box align={'center'} justify={'center'} fill>
                        <Text color={'mesh-accent-blue'}>
                          {this.getStoreAverageWeight(department.id)}
                        </Text>
                        <Text size="small" color={'mesh-accent-blue'}>
                          kg
                        </Text>
                      </Box>
                    }
                    color={'mesh-accent-blue'}
                    // fill
                    key={'btn_' + department.name}
                  />
                </>
              ))}
              <Box key={'temp1'} />
              <Box key="total" pad={'medium'} gap="small" round={'small'} background={'light-1'}>
                <Text weight={'bold'} size={'small'} color={'dark-6'}>
                  TOTAL
                </Text>
                <Text level={4} color="dark-3" size="large" weight={'bold'}>
                  {this.getTotal()} kg
                </Text>
              </Box>
              <Box key={'temp2'} />
            </Grid>
            <Box pad={'medium'}>
              <Button
                size={'large'}
                disabled={!this.allowSubmit()}
                primary
                label={'SUBMIT WEIGHTS'}
                onClick={this.submitWeights}
              />
            </Box>
          </Box>
        </Main>
      </Box>
    )
  }
}
InsertBulkScan.propTypes = {
  store: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  }),
  receiver: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    contact_email: PropTypes.string.isRequired
  })
}
export const ReceiversTable = (props) => {
  const { demoMode } = useContext(AppContext)
  return (
    <OpsResultsTable
      {...props}
      apiPath={'retail/receivers'}
      apiParams={{ receiver_type: 'HUB' }}
      apiFilters={[
        {
          label: 'Search',
          field: 'search',
          placeholder: 'enter email or name'
        },
        {
          label: 'Receiver Type',
          field: 'receiver_type',
          options: ['HUB', 'FARM'],
          defaultValue: 'HUB'
        },
        {
          label: 'ID',
          field: 'id',
          placeholder: 'Enter an id'
        }
        // {
        //   label: 'test',
        //   field: 'test',
        //   optionProps: { valueKey: 'id', labelKey: 'name' },
        //   options: departments,
        //   defaultValue: 2,
        //   placeholder: 'Enter an id'
        // }
      ]}
      heading={labelByMode('receivers', demoMode)}
      renderResultWith={{
        ResultComponent: Receiver,
        recordType: 'receiver',
        apiParams: { expand: ['store_set'] }
      }}
      showColumns={['id', 'name', 'address']}
    />
  )
}
export const StoresTable = (props) => {
  const { demoMode } = useContext(AppContext)
  return (
    <OpsResultsTable
      {...props}
      apiPath={'retail/stores'}
      // apiParams={{ receiver_type: 'HUB' }}
      apiFilters={[
        {
          label: 'Search',
          field: 'search',
          placeholder: 'enter a name'
        }
      ]}
      heading={labelByMode('stores', demoMode)}
      renderResultWith={{
        ResultComponent: Receiver,
        apiParams: { expand: ['receivers'] }
      }}
      showColumns={['id', 'name']}
    />
  )
}
const _Receiver = ({ fromApi: { apiLoading, result = {} }, closeAction }) => {
  // This will not dismount stacks from the Dom Tree. We can use one stack HOC and pass chilldren
  const stacks = {
    empty: 0,
    insertBulkScan: 1,
    donationReports: 2,
    bulkScanEntries: 3,
    storePosters: 4
  }
  const setStack = (stack, value = undefined) => {
    console.log(stack)
    setSelected({ stack: stack, ...(value && { value: value }) })
  }
  const {
    id,
    name,
    contact_email,
    receiver_type,
    store_set,
    address,
    receivers,
    signed_token
  } = result
  const [selected, setSelected] = useState({ stack: 0 })
  const motionStackProps = {
    initial: { opacity: 1, x: 500 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 1, x: 500 },
    transition: {
      type: 'spring',
      bounce: 0.1,
      duration: 0.6,
      staggerChildren: 0.07,
      delayChildren: 0.2
    }
  }

  const resetStack = () => {
    setSelected({ stack: 0 })
  }
  const commonStackProps = {
    width: { min: 'medium', max: 'xlarge' },
    fill: 'vertical',
    border: { side: 'top', color: 'light-4' },
    elevation: 'xlarge',
    background: 'white',
    closeAction: resetStack
  }
  const publicReportUrl = () => {
    return '/public/' + (store_set ? 'charity/' : 'store/') + id + '/reports?tk=' + signed_token
  }
  const publicPosterUrl = () => {
    return store_set ? null : '/public/store/' + id + '/posters?tk=' + signed_token
  }
  const commonButtonProps = {
    color: 'light-5',
    primary: true,
    plain: false,
    fill: 'horizontal'
  }
  return (
    <MotionBox
      // flex={'grow'}
      fill
      border={{ side: 'top', color: 'light-4' }}
      elevation={'xlarge'}
      background="light-2"
      variants={{
        open: { opacity: 1, y: 0 },
        collapsed: { opacity: 1, y: '110vh' }
      }}
      initial="collapsed"
      animate="open"
      exit="collapsed"
      transition={{
        type: 'spring',
        bounce: 0.1,
        duration: 0.6,
        staggerChildren: 0.07,
        delayChildren: 0.2
      }}
    >
      <LoadingHeader loading={apiLoading} />

      <PageCard
        show={!apiLoading}
        heading={receivers ? 'Store' : 'Receiver'}
        closeAction={closeAction}
      >
        <Main pad={'medium'} gap={'large'}>
          <Box flex={false} direction="row" fill={'horizontal'}>
            <Box width={'medium'} gap={'small'} border={{ side: 'bottom' }}>
              <Text level={2} weight={'bold'} size={'large'}>
                {name}
              </Text>
              <Paragraph size={'small'} margin={'xsmall'}>
                {address}
              </Paragraph>
              {contact_email && <Anchor href={'mailto:' + contact_email}>{contact_email}</Anchor>}
            </Box>
            <Box fill={'horizontal'} />
            <Box align={'end'} flex={'grow'} gap={'small'}>
              <Box direction={'row'} gap={'small'}>
                {store_set ? (
                  <Box direction={'row'} gap={'small'}>
                    <Button
                      label={'Reports'}
                      icon={<Analytics />}
                      {...commonButtonProps}
                      onClick={() => setStack(stacks.donationReports)}
                    />

                    <Button
                      {...commonButtonProps}
                      icon={<Globe />}
                      href={publicReportUrl()}
                      target={'_blank'}
                    />
                  </Box>
                ) : (
                  <Box direction={'row'} gap={'small'}>
                    {/*<Button*/}
                    {/*  label={'Posters'}*/}
                    {/*  icon={<DocumentImage />}*/}
                    {/*  {...commonButtonProps}*/}
                    {/*  onClick={() => setStack(stacks.storePosters)}*/}
                    {/*/>*/}
                    <Button
                      label={'Posters'}
                      {...commonButtonProps}
                      icon={<Globe />}
                      href={publicPosterUrl()}
                      target={'_blank'}
                    />
                  </Box>
                )}
              </Box>

              <Button
                label={'BulkScan'}
                icon={<Scan />}
                {...commonButtonProps}
                onClick={() => setStack(stacks.bulkScanEntries)}
              />
            </Box>
          </Box>

          <Box
            round={'small'}
            elevation={'small'}
            pad={'medium'}
            gap={'small'}
            background={'white'}
            flex={'grow'}
          >
            <Heading color="dark-6" level={5} margin={{ bottom: 'small', top: 'none' }}>
              {store_set && 'Stores'}
              {receivers && 'Receivers'}
            </Heading>
            <List
              pad={{ left: 'small', right: 'none', top: 'none', bottom: 'none' }}
              data={store_set || receivers}
              primaryKey={(item) => (
                <Text size="large" weight="bold">
                  {item.name}
                </Text>
              )}
              action={(item, index) => (
                <Menu
                  primary
                  color={'white'}
                  size={'small'}
                  key={index}
                  icon={<MoreVertical />}
                  hoverIndicator
                  items={[
                    {
                      label: 'Insert weight',
                      onClick: () => {
                        setStack(stacks.insertBulkScan, item)
                      }
                    }
                  ]}
                />
              )}
            />
          </Box>
        </Main>
      </PageCard>

      <AnimatePresence inital={true}>
        {selected.stack && (
          <MotionLayer
            plain
            modal={true}
            full
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            // transition={{ type: 'spring', duration: 0.7 }}
            onEsc={() => selected.stack && setSelected({ stack: 0 })}
            onClickOutside={() => setSelected({ stack: 0 })}
            transition={{
              type: 'spring',
              bounce: 0.1,
              duration: 0.6,
              staggerChildren: 0.07,
              delayChildren: 0.2
            }}
          >
            <MotionBox
              fill
              background={{ opacity: 'medium', color: 'dark-1', dark: false }}
              align={'end'}
            >
              <Stack
                interactiveChild={selected.stack}
                guidingChild={selected.stack}
                fill={'vertical'}
              >
                <Box width={commonStackProps.width} fill={'vertical'} />
                <PageCard
                  heading={'Insert bulk scans'}
                  key={stacks.insertBulkScan}
                  show={selected.stack === stacks.insertBulkScan}
                  {...commonStackProps}
                  motionProps={motionStackProps}
                >
                  {selected.stack === stacks.insertBulkScan && (
                    <InsertBulkScan
                      receiver={store_set ? { id, name, contact_email } : selected.value}
                      store={store_set ? selected.value : { id, name, contact_email }}
                      actions={{
                        bulkScanInserted: () => {
                          setSelected({ stack: 0 })
                        }
                      }}
                    />
                  )}
                </PageCard>

                <PageCard
                  key={stacks.donationReports}
                  heading={'Donation reports'}
                  show={selected.stack === stacks.donationReports}
                  {...commonStackProps}
                  width={'80vw'}
                  motionProps={motionStackProps}
                >
                  <DonationReportPage
                    apiParams={receivers ? { from_store_id: id } : { receiver_id: id }}
                  />
                </PageCard>

                <PageCard
                  key={stacks.bulkScanEntries}
                  heading={'BulkScan'}
                  show={selected.stack === stacks.bulkScanEntries}
                  {...commonStackProps}
                  width={'80vw'}
                  motionProps={motionStackProps}
                >
                  {/* <Heading pad={'medium'}>BulkScan Entries</Heading> */}
                  <BulkScanTable heading="" apiParams={{ receiver_id: id }} />
                  {/* Datable with custom search  */}
                  {/* <DonationReportPage
                    apiParams={receivers ? { from_store_id: id } : { receiver_id: id }}
                  /> */}
                </PageCard>

                <PageCard
                  key={stacks.storePosters}
                  heading={'Store Posters'}
                  show={selected.stack === stacks.storePosters}
                  {...commonStackProps}
                  width={'80vw'}
                  motionProps={motionStackProps}
                >
                  <Box flex={'grow'} overflow={'hidden'}>
                    <StorePosterPage
                      apiPath={'retail/reports/donation_totals'}
                      apiParams={receivers && { from_store_id: id }}
                    />
                  </Box>
                </PageCard>
              </Stack>
            </MotionBox>
          </MotionLayer>
        )}
      </AnimatePresence>
    </MotionBox>
  )
}
export const Receiver = withOpsApi(_Receiver)
